import api from 'Api'
import { SET_MESSAGE } from '../components/utils'

const URL = '/user'

const state = {
  users: []
}

const actions = {
  async deleteUser ({ commit }, payload) {
    let response
    try {
      response = await api().delete(`${URL}/${payload.id}?organization_id=${payload.org_id}`)
      SET_MESSAGE({ type: 'success', message: 'User is deleted' })
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    return response
  },
  async addUser (context, { payload, requestMethod }) {
    let response
    try {
      response = await api()[requestMethod](`${URL}`, payload)
      if (response && response.data.error) {
        SET_MESSAGE({ type: 'error', message: (response.data && response.data.error) || 'Error' })
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    return response.data
  }
}

const mutations = {
  SET_USER (state, { payload }) {
    state.users.push(payload)
  },
  UNSET_USER (state, id) {
    state.users = state.users.filter(u => u.entity_id !== id)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  name: 'usersTeamsServices'
}
